import script from "./XAI.vue?vue&type=script&setup=true&lang=js"
export * from "./XAI.vue?vue&type=script&setup=true&lang=js"

import "./XAI.vue?vue&type=style&index=0&id=458f7968&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-458f7968"]])

export default __exports__